import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ClipboardList, Users, MessageSquare, ShieldCheck } from "lucide-react";
import { IMAGES } from "../../mock";

const features = [
  { icon: ClipboardList, title: "Detailed, transparent quotes", text: "Clear, itemized pricing so you know exactly what to expect before your project begins." },
  { icon: Users, title: "Dedicated project team", text: "Work with a consistent coordinator and contractor from start to finish." },
  { icon: MessageSquare, title: "Clear communication", text: "Every step is planned and communicated so you're never left guessing." },
  { icon: ShieldCheck, title: "Licensed & insured", text: "Fully licensed, insured and committed to quality craftsmanship on every job." },
];

export default function WhyChooseUs() {
  return (
    <section className="py-24 bg-white overflow-hidden">
      <div className="container-x">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image with arch shape */}
          <div className="relative reveal-left">
            <div className="shape-arch-top max-w-[460px] mx-auto">
              <img src={IMAGES.kitchen2} alt="Renovation team planning" className="w-full h-[540px] object-cover" />
            </div>
            <div className="absolute -bottom-6 -left-2 sm:left-6 bg-[#0f2740] text-white px-7 py-6 rounded-2xl shadow-xl max-w-[220px] animate-floaty">
              <div className="font-display text-3xl font-bold">14+</div>
              <div className="text-[#a9c6dd] text-sm">Years of trusted craftsmanship</div>
            </div>
            <div className="absolute -top-4 right-6 w-24 h-24 rounded-full border-2 border-[#e8e0d2] hidden sm:block" />
          </div>

          {/* Content */}
          <div className="reveal-right">
            <div className="flex items-center gap-3 mb-4">
              <span className="h-px w-10 bg-[#2f9fe6]" />
              <span className="text-[#2f9fe6] tracking-[0.24em] text-xs font-semibold uppercase">Why Clients Choose Us</span>
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0f2740] leading-tight mb-6">
              A smoother renovation experience from start to finish
            </h2>
            <p className="text-[#6b7683] text-lg leading-relaxed mb-10">
              We create spaces that feel thoughtful, functional, and built to last. From the first conversation to the final details, we focus on clear communication, quality craftsmanship, and a renovation experience that feels organized and professional.
            </p>

            <div className="grid sm:grid-cols-2 gap-6 mb-10">
              {features.map((f) => (
                <div key={f.title} className="flex gap-4">
                  <div className="shrink-0 w-12 h-12 rounded-xl bg-[#eaf5fd] flex items-center justify-center">
                    <f.icon className="w-6 h-6 text-[#2f9fe6]" />
                  </div>
                  <div>
                    <h4 className="font-display font-semibold text-[#0f2740] mb-1">{f.title}</h4>
                    <p className="text-sm text-[#6b7683] leading-relaxed">{f.text}</p>
                  </div>
                </div>
              ))}
            </div>

            <Link to="/projects" className="group inline-flex items-center gap-2 px-7 py-3.5 rounded-full border-2 border-[#2f9fe6] text-[#2f9fe6] font-semibold hover:bg-[#2f9fe6] hover:text-white transition-all">
              Check Out More Projects
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
